<p-toast></p-toast>

<p-table
	[value]="signups"
	[loading]="loading"
	class="p-datatable-sm"
	responsiveLayout="scroll"
	[paginator]="true"
	[rows]="10"
	[showCurrentPageReport]="true"
	dataKey="id"
	styleClass="mt-3 p-datatable-workflow p-datatable-gridlines p-datatable-striped"
>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="createdDate">
				Signup Date
				<p-sortIcon field="createdDate"></p-sortIcon>
			</th>
			<th pSortableColumn="remainingDaysLeft">
				Days Left
				<p-sortIcon field="remainingDaysLeft"></p-sortIcon>
			</th>
			<th>Property</th>
			<th pSortableColumn="timeZone">
				Time Zone
				<p-sortIcon field="timeZone"></p-sortIcon>
			</th>
			<th pSortableColumn="billingId">
				Billing ID
				<p-sortIcon field="billingId"></p-sortIcon>
			</th>
			<th pSortableColumn="paymentCycle">
				Pricing Tier
				<p-sortIcon field="paymentCycle"></p-sortIcon>
			</th>
			<th pSortableColumn="paymentCycle">
				Payment Cycle
				<p-sortIcon field="paymentCycle"></p-sortIcon>
			</th>
			<th>Actions</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-signup>
		<tr>
			<td>{{ signup.createdDate | date: 'dd/MM/yyyy' }}</td>

			<td>{{ signup.remainingDaysLeft }}</td>

			<td>
				(<span style="color: rebeccapurple">{{ signup.id }}</span>)
				{{ signup.propertyName }}
			</td>

			<td>{{ signup.timeZone }}</td>

			<td>{{ signup.billingId || '-' }}</td>

			<td>{{ signup.pricingTierCode || '-' }}</td>

			<td>{{ getPaymentCycleLabel(signup.paymentCycle) }}</td>

			<td class="flex gap-2">

				<!-- Disable Account -->
				<button
					(click)="disableAccount(signup.id)"
					pButton
					icon="pi pi-lock"
					class="p-button-sm p-button-danger"
					style="width: 2.5rem; height: 2.5rem"
					title="Disable Account"
				></button>

				<!-- Create Invoice (only if billingId exists) -->
				<button
					*ngIf="signup.billingId"
					(click)="createRepeatingInvoice(signup.id)"
					pButton
					icon="pi pi-file"
					class="p-button-sm p-button-success"
					style="width: 2.5rem; height: 2.5rem"
					title="Create Invoice"
				></button>
			</td>
		</tr>
	</ng-template>
</p-table>
